<lcp-header></lcp-header>

<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section class="lcp-section">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>

    <section *ngFor="let section of fields['sections']; let i = index;"
      [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
      [class.is-inverted]="section.fields['inverted']">

        <!-- <h2 *ngIf="section.fields['title']" class="section-title">
          {{ section.fields['title'] }}
        </h2> -->
      
        <!-- <div class="section-main-content"> -->
          <ng-container *ngIf="i == 0">
            <ng-content *ngTemplateOutlet="servicesServicesTemplate; context:{ section: section }"></ng-content>
          </ng-container>
  
          <ng-container *ngIf="i == 1">
            <ng-content *ngTemplateOutlet="servicesBottomSection; context:{ section: section }"></ng-content>
          </ng-container>
      <!-- </div> -->
    </section>
  </ng-container>
</div> 

<ng-template #servicesServicesTemplate let-section="section">
  <div class="lcp-section-content">
    <h2 *ngIf="section.fields['title']" class="section-title">
      {{ section.fields['title'] }}
    </h2>

    <div class="section-main-content">
      <div class="services-services-container">
        <div class="service-divider"></div>
        <ng-container *ngFor="let block of section.fields['items']; index as i">
          <div class="services-service-container"
            (mouseenter)="handleMouseEnterService($event, block)">
            <div class="service-wrapper-mobile typable-wrapper-mobile display-block-only-sm">
              <ng-content *ngTemplateOutlet="servicesServiceMobile; context:{ block: block, index: i }"></ng-content>
            </div>

            <div class="service-wrapper-desktop  typable-wrapper-desktop display-none-sm">
              <ng-content *ngTemplateOutlet="servicesServiceDesktop; context:{ block: block, index: i }"></ng-content>
            </div>

            <div class="services-service-icon-container" *ngIf="block.fields['items']">
              <div class="services-service-image" *ngIf="block.fields['media']"
                [style.bottom]="block.fields['items'][0]['fields']['metadata']['bottom']">
                <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])"
                  [style.margin-right]="block.fields['items'][0]['fields']['metadata']['right']">
              </div>
              <div class="services-service-video"
                [style.bottom]="block.fields['items'][0]['fields']['metadata']['bottom']">
                <video muted preload="auto"
                  [style.margin-right]="block.fields['items'][0]['fields']['metadata']['right']">
                  <source *ngIf="!isSafari" [src]="lcpHelper.urlFromMedia(block.fields['items'][0]['fields']['media'])" type="video/webm">
                  <source *ngIf="isSafari" [src]="lcpHelper.urlFromMedia(block.fields['items'][0]['fields']['mp4'])" type="video/mp4">
                </video>
                <!-- <lottie-player
                  controls
                  mode="normal"
                  [src]="lcpHelper.urlFromMedia(block.fields['items'][0]['fields']['lottieFile'])" >
                </lottie-player> -->
              </div>
            </div>
          </div>
          <div class="service-divider"></div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #servicesServiceDesktop let-block="block" let-index="index">
  <div [ngClass]="['services-service', 'services-service-' + index, 'typable-container']" 
    [id]="'services-service-desktop-' + index"
    (mouseover)="handleHoverService({ event: $event, block: block, index: index })"
    (mouseleave)="handleBlurService({ event: $event, index: index })"
    (click)="handleSelectService(block)"
    (keydown.enter)="handleSelectService(block)"
    tabindex="0">

    <!-- (focus)="handleHoverService({ block: block, index: index })" -->

    <div class="services-service-flex">
      <div class="services-service-flex-left">
        <h4 class="services-service-title">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text font-weight-400"></span>
            <span class="typable-link font-weight-700 typable-repeatable"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <!-- <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div> -->
          <div class="typable-text-placeholder word-break-all">{{ descriptionPlaceholder }}</div>
        </div>
      </div>
      
      <div class="services-service-flex-right">
        <!-- <div *ngIf="learnMoreArrowMedia"
          class="services-service-learn-more-image-container">
          <img class="services-service-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
        </div> -->
        
        <!-- <div class="services-service-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div> -->
      </div>
        <!-- <div class="services-service-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div> -->
    </div>
  </div>
</ng-template>

<ng-template #servicesServiceMobile let-block="block" let-service="service">
  <div class="services-service typable-container">
    <div class="services-service-flex">
      <div class="services-service-flex-left">
        <h4 class="services-service-title">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div>
        </div>
      </div>
      
      <div class="services-service-flex-right">
        <!-- <div *ngIf="learnMoreArrowMedia"
          class="services-service-learn-more-image-container">
          <img class="services-service-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
        </div> -->
        <!-- <div class="services-service-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div> -->
      </div>
    </div>
  </div>
</ng-template>

<ng-template #servicesBottomSection let-section="section">
  <div class="lcp-section-content padding-bottom-0">
    <ng-container *ngFor="let block of section.fields['items']; index as i">
      <div class="display-flex services-our-strategy-flex">
        <div class="flex-45-not-sm">
          <h2 *ngIf="section.fields['title']" class="section-title">
            {{ section.fields['title'] }}
          </h2>
          <div class="section-main-content">
              <lcp-rich-text
                [document]="block.fields['body']">
              </lcp-rich-text>
              <!-- class="lcp-subheading" -->
          </div>
        </div>

        <div class="flex-50-not-sm">
          <div *ngIf="block.fields['media']" class="services-img--our-strategy">
            <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>